export const MAX_ONE_COLUMN_LENGTH = 19
